var styleReducerNoOp = function styleReducerNoOp(styles) {
  return styles;
};

export default styleReducerNoOp;